import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Row from "./Row";
import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";

type Props = {
  fulfillmentInfo: TransactionDetails["payment"]["fulfillmentInfo"];
};

export default function FulfillmentInfo({ fulfillmentInfo }: Props) {
  const tailwind = useTailwind();

  if (!fulfillmentInfo) {
    return null;
  }

  const { name, amount, currency } = fulfillmentInfo;

  const price = amount ? amountAsCurrency({ amount, currency }) : "Gratis";

  return (
    <View style={tailwind("mt-4")}>
      <CardText.Title text="Envío" />
      <Row style={tailwind("mt-1")}>
        <Text style={tailwind("flex-1")}>{name}</Text>
        <Text>{price}</Text>
      </Row>
    </View>
  );
}
